module.exports = __webpack_public_path__ + "img/pc_flower_R.c12b382.webp";